/* eslint-disable no-shadow */
import { GAME_ID, WORD_PARTS, REDUX_ACTIONS } from 'a/cutItOut/data/constants';
import CurriculumManager from 'a/cutItOut/content/CurriculumManager';
import { shuffleArray } from '../../../../lib/utilityFunctions';

export const initialState = {
  setNumber: 1,
  questionNumber: null,
  wordPartId: WORD_PARTS.BEGINNING,
  levelId: 1,
  targetWord: {},
  distractors: [],
  wordsSequence: [],
  picturesAreTapable: true,
  questionsCorrect: 0,
  questionsAnswered: 0,
  firstAttemptAnswers: 0,
  answerAttempts: 0,
  submittedWordLabels: [],
  interactionLocked: false,
  bonusTokensEarned: {
    [WORD_PARTS.BEGINNING]: 0,
    [WORD_PARTS.MIDDLE]: 0,
    [WORD_PARTS.ENDING]: 0,
  },
};

const roundReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.INIT_ROUND: {
      const questionNumber = CurriculumManager.getFirstQuestionNumber(
        action.payload.levelId,
        action.payload.setNumber,
      );
      const targetWord = CurriculumManager.getTargetWord(
        action.payload.levelId,
        action.payload.setNumber,
        questionNumber,
      );
      const distractors = CurriculumManager.getDistractors(questionNumber);
      return {
        ...initialState,
        targetWord,
        distractors,
        wordsSequence: shuffleArray([targetWord, ...distractors]),
        levelId: action.payload.levelId,
        questionNumber,
        setNumber: action.payload.setNumber,
        wordPartId: targetWord.word_part_id,
      };
    }
    case REDUX_ACTIONS.NEXT_QUESTION: {
      const targetWord = CurriculumManager.getTargetWord(
        state.levelId,
        state.setNumber,
        state.questionNumber + 1,
      );
      const distractors = CurriculumManager.getDistractors(state.questionNumber + 1);
      return {
        ...state,
        targetWord,
        distractors,
        wordsSequence: shuffleArray([targetWord, ...distractors]),
        questionNumber: state.questionNumber + 1,
        answerAttempts: 0,
        submittedWordLabels: [],
        interactionLocked: false,
        wordPartId: targetWord.word_part_id,
      };
    }
    case REDUX_ACTIONS.INCREMENT_ANSWER_ATTEMPTS:
      return {
        ...state,
        answerAttempts: state.answerAttempts + 1,
      };
    case REDUX_ACTIONS.SIMPLIFY_QUESTION:
      return {
        ...state,
        submittedWordLabels: [...state.submittedWordLabels, action.payload.incorrectPictureLabel],
      };
    case REDUX_ACTIONS.INCREMENT_QUESTIONS_CORRECT:
      return {
        ...state,
        questionsCorrect: state.questionsCorrect + 1,
      };
    case REDUX_ACTIONS.INCREMENT_QUESTIONS_ANSWERED:
      return {
        ...state,
        questionsAnswered: state.questionsAnswered + 1,
      };
    case REDUX_ACTIONS.INCREMENT_FIRST_ATTEMPT_ANSWERS:
      return {
        ...state,
        firstAttemptAnswers: state.firstAttemptAnswers + 1,
      };
    case REDUX_ACTIONS.SET_INTERACTION_LOCKED:
      return {
        ...state,
        interactionLocked: action.payload.interactionLocked,
      };
    case REDUX_ACTIONS.SET_BONUS_LEVEL_TOKENS:
      return {
        ...state,
        bonusTokensEarned: {
          ...state.bonusTokensEarned,
          [action.payload.wordPartId]: action.payload.tokensCount,
        },
      };
    case REDUX_ACTIONS.QUICK_ROUND: {
      const numQuestions = CurriculumManager.getStandardSetsAmount(state.levelId, state.setNumber);
      return {
        ...state,
        levelId: action.payload.levelId,
        questionsAnswered: numQuestions,
        questionsCorrect: action.payload.pass ? numQuestions : 0,
      };
    }
    default:
      return state;
  }
};

export default roundReducer;
